import React from 'react'
import { CSVLink } from 'react-csv'

export const ExportCSV = ({ data }) => {
  const headers = [
    { label: "_id", key: "_id" },
    { label: "idReferencia", key: "idReferencia" },
    { label: "name", key: "name" },
    { label: "apelido", key: "apelido" },
    { label: "email", key: "email" },
    { label: "date", key: "date" },
    { label: "documentType", key: "documentType" },
    { label: "documentNumber", key: "documentNumber" },
    { label: "ciudad", key: "ciudad" },
    { label: "direccion", key: "direccion" },
    { label: "codigo_mun_tu", key: "codigo_mun_tu" },
    { label: "codigo_gera", key: "codigo_gera" },
    { label: "codigo_dept_tu", key: "codigo_dept_tu" },
    { label: "complemento", key: "complemento" },
    { label: "celular", key: "celular" },
    { label: "localNumber", key: "localNumber" },
    { label: "localType", key: "localType" },
    { label: "ipUser", key: "ipUser" },
    { label: "dateRegister", key: "dateRegister" },
    { label: "acceptTerm", key: "acceptTerm" },
    { label: "UTMsource", key: "UTMsource" },
    { label: "UTMmedium", key: "UTMmedium" },
    { label: "UTMcampaign", key: "UTMcampaign" },
    { label: "UTMterm", key: "UTMterm" },
    { label: "UTMcontent", key: "UTMcontent" },
    { label: "URLorigin", key: "URLorigin" }
  ];

  return (
    <div>
      <CSVLink className="btn--download" data={data} headers={headers} filename={"my-file.csv"} target="_blank">Download me</CSVLink>
    </div>
  )
}